import React from 'react';
import PropTypes from 'prop-types';
import { Chip, Avatar, createMuiTheme, MuiThemeProvider, makeStyles } from '@material-ui/core';
import { colors } from 'kangarootime-ui';

const theme = createMuiTheme({
  palette: {
    primary: {
      main: colors.brand_1
    }
  }
});

const useStyles = makeStyles(theme => ({
  chip: {
    margin: 2
  }
}));

const UserChip = ({
  avatar,
  initials,
  label,
  onDelete,
  ...props
}) => {
  const classes = useStyles();

  return (
    <MuiThemeProvider theme={theme}>
      <Chip
        avatar={avatar ? <Avatar alt={`${label}-chip`} src={avatar} /> : <Avatar>{initials}</Avatar>}
        label={label}
        onDelete={onDelete}
        size='small'
        color='primary'
        className={classes.chip}
      />
    </MuiThemeProvider>
  );
};

UserChip.propTypes = {
  avatar: PropTypes.string,
  initials: PropTypes.string,
  label: PropTypes.string,
  onDelete: PropTypes.func
};

export default UserChip;
